import data from "bootstrap/js/src/dom/data";

export default class CostTypeService {

  static apiRelativePath = "/cost-types"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  getAll = async () => {
    return this.apiClient.get(`${CostTypeService.apiRelativePath}`);
  }

  create = async (data) => {
    return this.apiClient.post(`${CostTypeService.apiRelativePath}`, data);
  }

  put = async (id, data) => {
    return this.apiClient.put(`${CostTypeService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${CostTypeService.apiRelativePath}/${id}`);
  }

  reorder = async (data) => {
    return this.apiClient.post(`${CostTypeService.apiRelativePath}/reorder`, data);
  }
}
